import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { ThemeProvider, createTheme } from "@mui/material";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { msalConfig } from "./config/authConfig";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
  },
});

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// Removed React.StrictMode to prevent intentional double-mount in dev which
// was triggering multiple authentication flows.
root.render(
  <MsalProvider instance={msalInstance}>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </MsalProvider>
);
